import React from 'react';
import { StyledFlightList } from '../FlightList';
import { FlightListItemShimmer } from './FlightListItemShimmer';
import { NavigationPlaceholder } from './NavigationPlaceholder';

interface IShimmerFlightListProps {
	listLength: number;
}

export const FlightListShimmer = ({ listLength }: IShimmerFlightListProps) => {
	const items = new Array(listLength).fill('');

	return (
		<>
			<NavigationPlaceholder />
			<StyledFlightList data-testid="flight-list-shimmer">
				{items.map((_, i) => (
					// eslint-disable-next-line react/no-array-index-key
					<FlightListItemShimmer key={`shimmer-${i}`} />
				))}
			</StyledFlightList>
		</>
	);
};
